import { useCallback, useState } from 'react';
import { get } from 'lodash';
import { useDataService } from '../../../services/ApiDataService';
import { useRequestState } from '../../../utilities/Hooks';
import { useIsPgm } from '../../../stores/EnvironmentStore';

const TEST_URL = '/api/v3/systemconfiguration/smtp/verify';

export default function useSmtpVerify() {
    const { isLoading, methods } = useRequestState();
    const dataService = useDataService();

    const [smtpSuccess, setSmtpSuccess] = useState(false);
    const [hasTested, setHasTested] = useState(false);
    const [smtpResponse, setSmtpResponse] = useState({});
    const [smtpMessage, setSmtpMessage] = useState('');
    const [isPgm] = useIsPgm();

    const testEmail = useCallback(
        async ({
            from,
            host,
            port,
            to,
            security,
            username,
            password,
            disableServerCertVerification,
            headerName,
            headerValue,
        }) => {
            methods.onInit();
            setHasTested(true);

            try {
                const URL = isPgm ? `/pgm/${TEST_URL}` : TEST_URL;

                // Create smtpHeaders array from headerName and headerValue
                const smtpHeaders = [];
                if (headerName && headerValue) {
                    smtpHeaders.push({ name: headerName, value: headerValue });
                }

                const response = await dataService.post(URL, {
                    from,
                    host,
                    port,
                    to,
                    security,
                    username,
                    password,
                    disableServerCertVerification,
                    smtpHeaders,
                });

                setSmtpResponse(response);
                setSmtpSuccess(get(response, 'data.connected', false));
                setSmtpMessage(get(response, 'data.message', ''));
                methods.onLoad(response);
            } catch (e) {
                setSmtpResponse(e);
                setSmtpSuccess(false);
                setSmtpMessage('Failed to send test email');
                methods.onError(e);
            }
        },
        [dataService, methods, isPgm]
    );

    return {
        testEmail,
        isLoading,
        smtpResponse,
        smtpSuccess,
        smtpMessage,
        hasTested,
    };
}
